import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const feedbackService = {
	/**
	 * Get all feedback types
	 */
	getFeedbackTypes(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/feedback/types', config)
	},
}

export default feedbackService
